import React, { useCallback } from 'react';
import { batch } from 'react-redux';

import {
  CLASS_TEMPLATE_BULK_UPDATE_TYPES,
  EditLectureContentForm,
  LECTURE_CONTENT_OPTIONS,
  setBulkUpdateSyncConfirmModalState,
  setBulkUpdateSyncType,
} from 'features/classCreation';
import BulkUpdateSyncButton from '../BulkUpdateSyncButton';
import EditableSection from 'components/EditableSection';
import Field from 'components/Field';
import LectureContentChip from '../LectureContentChip';
import useAppDispatch from 'hooks/useAppDispatch';

function LectureDetails({ academyTopic }) {
  const dispatch = useAppDispatch();
  const { academy_topic_lecture_contents: academyTopicLectureContents } =
    academyTopic || {};

  const handleBulkUpdateSyncing = useCallback(
    (bulkUpdateSyncType) => {
      batch(() => {
        dispatch(setBulkUpdateSyncType(bulkUpdateSyncType));
        dispatch(setBulkUpdateSyncConfirmModalState(true));
      });
    },
    [dispatch]
  );

  return (
    <Field
      label="Lecture Details"
      labelClassName="m-b-xs"
      actions={
        <BulkUpdateSyncButton
          handleOnSync={() => {
            handleBulkUpdateSyncing(
              CLASS_TEMPLATE_BULK_UPDATE_TYPES.lectureContents
            );
          }}
        />
      }
    >
      <div className="m-b-s">
        {Object.keys(LECTURE_CONTENT_OPTIONS).map((contentType) => (
          <LectureContentChip
            academyTopicId={academyTopic.id}
            contentType={contentType}
            title={LECTURE_CONTENT_OPTIONS[contentType].label}
            key={contentType}
          />
        ))}
      </div>
      {academyTopicLectureContents.map((topicLectureContent) => {
        const lectureContent = topicLectureContent.lecture_content;
        const label =
          LECTURE_CONTENT_OPTIONS[lectureContent.content_type].label;

        return (
          <EditableSection
            canEdit
            title={label}
            className="m-b-s"
            key={lectureContent.id}
          >
            {(editableProps) => (
              <EditLectureContentForm
                {...editableProps}
                academyTopicId={academyTopic.id}
                lectureContent={lectureContent}
                label={label}
              />
            )}
          </EditableSection>
        );
      })}
    </Field>
  );
}

export default LectureDetails;
